import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../../services/authService';

const UsersAccessOverview = ({ onNavigate }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    adminAPI.getUsersAccessOverview()
      .then((res) => setData(res?.data?.totals || res?.data || {}))
      .catch(() => setError('Unable to load overview.'));
  }, []);

  const t = data || {};
  const cards = [
    ['Total users', t.totalUsers],
    ['Active users', t.activeUsers],
    ['Pending invitations', t.pendingInvitations],
    ['Locked users', t.lockedUsers],
    ['Without System Roles', t.usersWithoutRoles],
    ['Without Project Access', t.usersWithoutProjects],
    ['Active System Roles', t.activeRoles],
    ['Consultants', t.consultants],
    ['Consultants assigned', t.consultantsAssigned],
    ['Invites expiring soon', t.invitationsExpiringSoon],
  ];

  const attention = [
    { label: 'Users without project access', count: t.usersWithoutProjects, tab: 'users', filter: 'no-projects' },
    { label: 'Users without System Roles', count: t.usersWithoutRoles, tab: 'users', filter: 'no-roles' },
    { label: 'Locked accounts', count: t.lockedUsers, tab: 'users', filter: 'locked' },
    { label: 'Failed invitations', count: t.failedInvitations, tab: 'invitations', filter: 'FAILED' },
    { label: 'Expired invitations', count: t.expiredInvitations, tab: 'invitations', filter: 'EXPIRED' },
  ].filter((x) => Number(x.count) > 0);

  return (
    <div>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="ua-kpi-grid" style={{ marginBottom: 16 }}>
        {cards.map(([label, value]) => (
          <div className="ua-kpi" key={label}>
            <p className="ua-kpi__label">{label}</p>
            <p className="ua-kpi__value">{value ?? '—'}</p>
          </div>
        ))}
      </div>

      <div className="panel ua-panel" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>Attention required</h3>
        {attention.length === 0 ? (
          <p style={{ color: '#64748b', margin: 0 }}>No urgent items.</p>
        ) : (
          <div className="ua-attention-list">
            {attention.map((item) => (
              <button
                key={item.label}
                type="button"
                className="ua-attention-item"
                onClick={() => onNavigate?.(item.tab, item.filter)}
              >
                <strong>{item.count}</strong> — {item.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="panel ua-panel">
        <h3 style={{ marginTop: 0 }}>Quick actions</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <button type="button" className="btn-primary" onClick={() => onNavigate?.('users', 'add')}>Add User</button>
          <button type="button" className="btn-secondary" onClick={() => onNavigate?.('roles', 'create')}>Create System Role</button>
          <button type="button" className="btn-secondary" onClick={() => onNavigate?.('project-access')}>Assign Project Access</button>
          <button type="button" className="btn-secondary" onClick={() => onNavigate?.('consultants', 'add')}>Add Consultant</button>
          <button type="button" className="btn-secondary" onClick={() => onNavigate?.('invitations')}>Send Invitation</button>
        </div>
      </div>
    </div>
  );
};

export default UsersAccessOverview;
